module.exports = __webpack_public_path__ + "static/DezmaraPosterThumb-19655d8fb5589634e2797dace775c8bb.png";